export { default as ManagersPage } from "./pages/ManagersPage";
export { default as managerConstants } from "./constants";
export { default as managerReducer } from "./reducer";



// WEBPACK FOOTER //
// ./src/modules/manager/index.js